




























































import TransitionHeight from '../../components/transition-height.component.vue';

import { ROUTER_CONSTS } from '../../router/router.consts';

import EqualizeForm from '../equalize/equalize-form.view.vue';

export default {
  name: 'equalize-dashboard-form',
  components: {
    TransitionHeight
  },
  mixins: [EqualizeForm],
  data: function () {
    return {
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.equalizeDashboard.update),
      item: {
        enabled: false,
        title: undefined,
        extra: {
          notes: undefined
        },
        fields: []
      }
    };
  }
};

